<div class="grid">
	<div class="col-12">
		<div class="card">
			<h5 *ngIf="router.url == '/app/users'">Clientes</h5>
			<p-table
				#dt1
				[value]="users"
				dataKey="id"
				[rows]="10"
				[loading]="loading"
				[rowHover]="true"
				[paginator]="true"
				[globalFilterFields]="['name', 'email', 'phone', 'status_string']"
				responsiveLayout="scroll"
			>
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<button pButton label="Limpiar" class="p-button-rounded mb-2" (click)="clear(dt1)"></button>
						<span class="p-input-icon-left">
							<i class="pi pi-circle-fill"></i>
							<input pInputText type="text" #filter (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Buscar" class="w-full" />
						</span>
						<div class="text-right">
							<button pButton tooltipPosition="top" pTooltip="Nuevo usuario" class="p-button-raised p-button-outlined m-1" icon="pi pi-plus" (click)="showDialog()"></button>
							<button pButton pRipple tooltipPosition="top" label="Actualizar" pTooltip="Actualizar listado de usuarios" type="button" icon="pi pi-refresh" class="p-button-raised p-button-outlined m-1" (click)="loadUsers(); clear(dt1)"></button>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="header">
					<tr>
						<!-- <th class="text-center">
							Avatar
						</th> -->
						<th class="text-center" pSortableColumn="codes.code">
							<p-sortIcon field="codes.code"></p-sortIcon>
							Código
						</th>
						<th class="text-center" pSortableColumn="identification">
							<p-sortIcon field="identification"></p-sortIcon>
							DNI
						</th>
						<th class="text-center" pSortableColumn="name">
							<p-sortIcon field="name"></p-sortIcon>
							Nombre
						</th>
						<th class="text-center" pSortableColumn="email">
							<p-sortIcon field="email"></p-sortIcon>
							Email
						</th>
						<th class="text-center" pSortableColumn="status_string">
							<p-sortIcon field="status_string"></p-sortIcon>
							Estado
						</th>
						<th></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-user>
					<tr>
						<!-- <td class="text-center" style="max-width: 5rem">
							<img src="{{ user.avatar }}" class="img-rounded shadow-4" *ngIf="user.avatar">
						</td> -->
						<td class="text-center" style="min-width: 5rem">{{ user.codes?.code || '-' }}</td>
						<td class="text-center" style="min-width: 5rem">{{ user.identification }}</td>
						<td class="text-center" style="min-width: 5rem">{{ user.name }}</td>
						<td class="text-center" style="min-width: 5rem">
							{{ user.email.includes('makemark.nytelweb.com') ? '': user.email }}
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ user.status_string }}
						</td>
						<td class="text-center" style="min-width: 1rem">
							<button pButton pRipple type="button" tooltipPosition="top" pTooltip="Inversiones" icon="pi pi-building-columns" class="p-button-info p-button-raised p-button-outlined m-1" (click)="investmentsUser(user)"></button>

							<button *ngIf="user.status != -1" pButton pRipple type="button" tooltipPosition="top" pTooltip="Eliminar usuario" icon="pi pi-trash" class="p-button-danger p-button-raised p-button-outlined m-1" (click)="deleteUser(user)"></button>

							<button *ngIf="user.status != -1" pButton pRipple type="button" tooltipPosition="top" pTooltip="Editar usuario" icon="pi pi-pencil" class="p-button-raised p-button-outlined m-1" (click)="showDialog(user)"></button>
							
							<button
							   *ngIf="user.status === 1 || user.status === 0"
								pButton
								pRipple
								type="button"
								[pTooltip]="user.status === 1 ? 'Desactivar' : 'Activar'"
								icon="pi {{ user.status === 1 ? 'pi-thumbs-down' : 'pi-thumbs-up' }}"
								class="p-button-raised p-button-outlined m-1 p-button-{{ user.status === 1 ? 'danger' : 'success' }}"
								(click)="updateStatus(user)"
							></button>
						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7" class="text-center">Sin resultados</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Cargando usuarios...</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-dialog header="Recortador de imagen" [style]="{ width: '70vw' }" [(visible)]="croppedActive" [modal]="true" [draggable]="false" [resizable]="false">
	<div class="croppe">
		<image-cropper
		[imageChangedEvent]="imageChangedEvent"
		[maintainAspectRatio]="true"
		[aspectRatio]="1 / 1"
		resizeToHeight="512"
		format="jpeg"
		output="base64"
		(imageCropped)="imageCropped($event)"
		(imageLoaded)="imageLoaded($event)"
		(cropperReady)="cropperReady()"
		(loadImageFailed)="loadImageFailed()"
		class="cropper">
	  </image-cropper>
	</div>
</p-dialog>

<p-dialog [header]="'Datos del cliente'" [(visible)]="dialogUser" [modal]="true" [style]="{ width: '80vw' }" [draggable]="false" [resizable]="false" (onHide)="resetForm()">
	<form [formGroup]="form">
		<div class="container-img">
			<div class="custom-file-upload" *ngIf="stringPhoto">
				<img [src]="stringPhoto" style="width: 220px" alt="Foto cargada" />
				<button class="ml-2" type="button" pButton icon="pi pi-trash" (click)="deletePhoto()"></button>
			</div>
			<div class="custom-file-upload">
				<input id="photoInputImage" type="file" (change)="handleUpload($event)" accept=".jpg,.png" />
				<label class="btn-img">Selecciona imagen</label>
			</div>
		</div>

		<div class="grid p-fluid mt-3 text-center">
				<div class="field col-12 md:col-4 md:col-offset-4">
					<label>Código *</label>
					<input [readonly]="isCodeDisabled" type="tel" formControlName="code" pInputText class="w-full mb-3 text-center" />
					<small class="p-error" *ngIf="form.get('code').errors && form.get('code').touched && form.get('code').hasError('required')">Requerido</small>
					<small class="p-error" *ngIf="form.get('code').hasError('pattern') && form.get('code').touched">Introduzca sólo letras y numéros</small>
				</div>
		</div>
		<div class="grid p-fluid mt-3">
				<div class="field col-12 md:col-3">
					<label>DNI *</label>
					<input type="text" formControlName="identification" pInputText class="w-full mb-3" />
					<small class="p-error" *ngIf="form.get('identification').errors && form.get('identification').touched && form.get('name').hasError('required')">Requerido</small>
				</div>
				<div class="field col-12 md:col-3">
					<label>Nombre *</label>
					<input type="text" formControlName="name" pInputText class="w-full mb-3" />
					<small class="p-error" *ngIf="form.get('name').errors && form.get('name').touched && form.get('name').hasError('required')">Requerido</small>
					<small class="p-error" *ngIf="form.get('name').hasError('pattern') && form.get('name').touched">Formato incorrecto</small>
				</div>
				<div class="field col-12 md:col-3">
					<label>Email</label>
					<input type="email" formControlName="email" pInputText class="w-full mb-3" />
					<small class="p-error" *ngIf="form.get('email').errors && form.get('email').touched && form.get('email').hasError('required')">Requerido</small>
					<small class="p-error" *ngIf="form.get('email').hasError('email') && form.get('email').touched">Ingrese un email con formato válido</small>
				</div>
				<div class="field col-12 md:col-3">
					<label>Teléfono</label>
					<input type="tel" formControlName="phone" pInputText maxlength="9" class="w-full mb-3" />
					<small class="p-error" *ngIf="form.get('phone').errors && form.get('phone').touched && form.get('phone').hasError('required')">Requerido</small>
					<small class="p-error" *ngIf="form.get('phone').hasError('pattern') && form.get('phone').touched">Introduzca valores numéricos</small>
				</div>
				<div class="field col-12 md:col-3"  *ngIf="mode != 'register'">
					<label>Contraseña</label>
					<p-password formControlName="password" [toggleMask]="true" autocomplete="new-password"></p-password>
				</div>
				<div class="field col-12 md:col-3"  *ngIf="mode != 'register'">
					<label>Confirmar contraseña</label>
					<p-password formControlName="password_confirmation" [toggleMask]="true" autocomplete="new-password"></p-password>
					<small class="p-error" *ngIf="form.get('password_confirmation').errors && form.get('password_confirmation').touched && form.get('password_confirmation').hasError('required')">Requerido</small>
					<small class="p-error" *ngIf="form.get('password_confirmation').errors && form.get('password_confirmation').touched">Contraseña y confirmación de contraseña no coinciden</small>
				</div>
			<div class="flex justify-content-end col-12">
				<p-button styleClass="p-button-rounded" [label]="mode === 'register' ? 'Guardar' : 'Actualizar'" (click)="mode === 'register' ? registerUser() : updateUser()" [loading]="loading"></p-button>
			</div>
		</div>
	</form>
</p-dialog>
